import Button from "components/button/button";
import JobListing from "components/job-listing/job-listing";

type JobListingScreenProps = {
  body: string;
  location: string;
  payMax: number;
  payMin: number;
  title: string;
  url: string;
};

const JobListingScreen = ({
  title,
  location,
  payMin,
  payMax,
  body,
  url,
}: JobListingScreenProps) => {
  return (
    <JobListing
      expanded
      action={
        <div className="tr pt3">
          <Button component="a" href={url} style="rose">
            Apply
          </Button>
        </div>
      }
      body={body}
      className="center mw7 mv3"
      location={location}
      payMax={payMax}
      payMin={payMin}
      title={title}
    />
  );
};

export default JobListingScreen;
